import { render } from "./UserEdit.vue?vue&type=template&id=87103dac&scoped=true"
import script from "./UserEdit.vue?vue&type=script&lang=js"
export * from "./UserEdit.vue?vue&type=script&lang=js"

import "./UserEdit.vue?vue&type=style&index=0&id=87103dac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-87103dac"

export default script